import { useCallback } from 'react';

import { useQToast, QToastOptions } from 'quotient/vNext';

import { ToastContent } from '../components/shared/ToastContent';

export type TQToastOptions = {
  title?: string;
  description?: string;
  status?: 'error' | 'success' | 'warning' | 'info';
};

export const useToast = () => {
  const { error: errorToast, success: successToast, warning: warningToast, info: infoToast } = useQToast();

  return useCallback(
    (options: Omit<QToastOptions, 'variant'> & TQToastOptions = {}) => {
      const { title, description, status = 'success' } = options;
      const content = <ToastContent description={description} title={title} />;

      if (status === 'error') {
        errorToast({ ...options, description: content });
      } else if (status === 'success') {
        successToast({ ...options, description: content });
      } else if (status === 'warning') {
        warningToast({ ...options, description: content });
      } else if (status === 'info') {
        infoToast({ ...options, description: content });
      }
    },
    [errorToast, successToast, warningToast, infoToast],
  );
};
